export default "__VITE_ASSET__BWI9w344__"